export const fontOptions = [
  { id: '1', name: 'Roboto' },
  { id: '2', name: 'Lato' },
  { id: '3', name: 'Noto Sans' },
  { id: '4', name: 'Inter' },
  { id: '5', name: 'Agbalumo' },
  { id: '6', name: 'Montserrat' },
]
